import type { AccountLookup, SiteConfig } from "../lib/gboModels";
import {
  selectCanAttemptCheckout,
  selectNoPaymentDue,
} from "../features/checkout/checkoutSelectors";
import { getPaymentProviderLabel } from "../features/checkout/payment";

export function getAccountPageViewModel(accountLookup: AccountLookup, siteConfig: SiteConfig) {
  const noPaymentDue = selectNoPaymentDue(accountLookup.accountBalance);

  return {
    document: {
      customerName: accountLookup.customerName,
      subtitle: "Account payment",
      facts: [
        { label: "Customer", value: accountLookup.customerName, valueKind: "text" as const },
        {
          label: "Current account balance",
          value: accountLookup.accountBalance,
          valueKind: "money" as const,
        },
      ],
    },
    paymentRail: {
      canPay: selectCanAttemptCheckout(
        accountLookup.payment,
        siteConfig.payOnlineEnabled,
        accountLookup.accountBalance,
      ),
      balanceLabel: noPaymentDue ? "Status" : "Balance due",
      balanceValue: accountLookup.accountBalance,
      balanceValueKind: noPaymentDue ? ("paid" as const) : ("money" as const),
    },
    paymentPanel: {
      customerId: accountLookup.customerId,
      accountBalance: accountLookup.accountBalance,
      payment: accountLookup.payment,
      payOnlineEnabled: siteConfig.payOnlineEnabled,
    },
    noPaymentDue,
    paymentProviderLabel: getPaymentProviderLabel(accountLookup.payment),
  };
}
